(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dopazen-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dz').forEach(function (root) {
    var slides = root.querySelectorAll('.dz__slide');
    var thumbs = root.querySelectorAll('.dz__thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
      if (thumbs[current]) thumbs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.dataset.index)); }); });
    root.querySelectorAll('.dz__arrow').forEach(function (a) { a.addEventListener('click', function () { show(current + Number(a.dataset.dir)); }); });

    var input = root.querySelector('.dz__variant-input');
    root.querySelectorAll('.dz__radio').forEach(function (r) {
      r.addEventListener('change', function () {
        input.value = r.value;
        root.querySelectorAll('.dz__offer').forEach(function (o) { o.classList.toggle('is-selected', o.contains(r)); });
      });
    });

    var sub = root.querySelector('.dz__sub-check');
    var plan = root.querySelector('.dz__plan-input');
    if (sub && plan) sub.addEventListener('change', function () { plan.value = sub.checked ? plan.dataset.plan : ''; });

    var d = root.querySelector('.dz__delivery');
    if (d) {
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      function addBusinessDays(date, n) {
        var r = new Date(date);
        while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
        return r;
      }
      var now = new Date();
      d.querySelector('.dz__d-today').textContent = fmt.format(now);
      d.querySelector('.dz__d-eta').textContent = fmt.format(addBusinessDays(now, Number(d.dataset.min))) + ' – ' + fmt.format(addBusinessDays(now, Number(d.dataset.max)));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iseul-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dz').forEach(function (root) {
    var slides = root.querySelectorAll('.dz__slide');
    var thumbs = root.querySelectorAll('.dz__thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
      if (thumbs[current]) thumbs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.dataset.index)); }); });
    root.querySelectorAll('.dz__arrow').forEach(function (a) { a.addEventListener('click', function () { show(current + Number(a.dataset.dir)); }); });

    var input = root.querySelector('.dz__variant-input');
    root.querySelectorAll('.dz__radio').forEach(function (r) {
      r.addEventListener('change', function () {
        input.value = r.value;
        root.querySelectorAll('.dz__offer').forEach(function (o) { o.classList.toggle('is-selected', o.contains(r)); });
      });
    });

    var cd = root.querySelector('.dz__countdown');
    if (cd) {
      var pad = function (n) { return String(n).padStart(2, '0'); };
      // meme calcul que le minuteur de l'en-tete : heure de Paris, fin a 23:59:59
      var depuisMinuit = function () {
        var d = new Date();
        try {
          var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }).formatToParts(d);
          var h = 0, m = 0, s = 0;
          p.forEach(function (x) {
            if (x.type === 'hour') h = parseInt(x.value, 10) % 24;
            if (x.type === 'minute') m = parseInt(x.value, 10);
            if (x.type === 'second') s = parseInt(x.value, 10);
          });
          return h * 3600 + m * 60 + s;
        } catch (e) {
          return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
        }
      };
      var tick = function () {
        var sec = Math.max(0, 86399 - depuisMinuit());
        cd.textContent = pad(Math.floor(sec / 3600)) + ':' + pad(Math.floor(sec % 3600 / 60)) + ':' + pad(sec % 60);
      };
      tick(); setInterval(tick, 1000);
    }

    var sub = root.querySelector('.dz__sub-check');
    var plan = root.querySelector('.dz__plan-input');
    if (sub && plan) sub.addEventListener('change', function () { plan.value = sub.checked ? plan.dataset.plan : ''; });

    var d = root.querySelector('.dz__delivery');
    if (d) {
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      function addBusinessDays(date, n) {
        var r = new Date(date);
        while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
        return r;
      }
      var now = new Date();
      d.querySelector('.dz__d-today').textContent = fmt.format(now);
      d.querySelector('.dz__d-eta').textContent = fmt.format(addBusinessDays(now, Number(d.dataset.min))) + ' – ' + fmt.format(addBusinessDays(now, Number(d.dataset.max)));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iseul-promo-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ipb]').forEach(function (el) {
    var btn = el.querySelector('[data-ipb-close]');
    if (btn) btn.addEventListener('click', function () { el.hidden = true; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iseul-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-irv]').forEach(function (root) {
    var toggle = root.querySelector('[data-irv-toggle]');
    var wrap = root.querySelector('[data-irv-form]');
    if (toggle && wrap) {
      if (wrap.querySelector('[data-irv-open]')) {
        wrap.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        wrap.scrollIntoView({ block: 'center' });
      }
      toggle.addEventListener('click', function () {
        var open = wrap.hidden;
        wrap.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) { var first = wrap.querySelector('input:not([type=hidden])'); if (first) first.focus(); }
      });
    }
    var moreBtn = root.querySelector('[data-irv-more-btn]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-irv-more]').forEach(function (el) { el.hidden = false; });
        moreBtn.parentElement.remove();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
